import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ResponseData} from 'types/response-data';

const toggleOverpaymentUsage = api.injectEndpoints({
  endpoints: builder => ({
    toggleOverpaymentUsage: builder.mutation<Response, Request>({
      query: ({id}) => {
        return {
          method: 'POST',
          url: `overpayments/${id}/toggle-usage`,
        };
      },
    }),
  }),
});

type Request = {
  id?: ObjectId;
};

type Response = ResponseData<{affected_row: ObjectId}>;

export const {useToggleOverpaymentUsageMutation} = toggleOverpaymentUsage;
